import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  OnInit,
  HostListener,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from './models/auth/_services/auth.service';
import { ConfigService } from './services/config.service';
import { OauthService } from './services/ouath.service';
import { InactivityService } from './models/auth/_services/inactivity.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit, OnDestroy {
private readonly unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  private inactivitySubscription: Subscription;
  constructor(
    // private translationService: TranslationService,
    // private splashScreenService: SplashScreenService,
    private readonly router: Router,
    // private notificationsService:NotificationsService,
    // private tableService: TableExtendedService,
    private readonly authService: AuthService,
    private readonly inactivityService: InactivityService,
    private readonly configService: ConfigService,
    private readonly oauthService :OauthService,
    
  ) {

  }

 async ngOnInit() {

     // se carga la cofiguracion
     await this.configService.getAppConfig();
     await this.oauthService.getAppConfig();
  
     this.inactivityService.setTimeoutInactivityNew(this.configService.config.timeInactivity);
     this.inactivitySubscription = this.inactivityService.userInactive.subscribe(() => {
       this.handleUserInactivity();
     });

    const routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {


        // scroll to top on every route change
        window.scrollTo(0, 0);

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
        }, 500);
      }
    });
    this.unsubscribe.push(routerSubscription);
 


    // window.addEventListener('resize', () => {
      this.adjustScale();
    // });

  }

  adjustScale() {

    const width = window.innerWidth;
    let scale = 1;
  
    if (width >= 1920) {
      scale = 1.1;
    } else if (width >= 1386 && width < 1920) {
      scale = 1.0;
    } else {
      scale = 0.9;
    }
  
    const body = document.body;
  
    body.style.transform = `scale(${scale})`;
    body.style.transformOrigin = 'top left';
    body.style.width = `${100 / scale}%`;

    document.documentElement.style.height = '100%';
body.style.height = `${100 / scale}%`;



  }

  private handleUserInactivity() {
    // Aquí puedes manejar la lógica de cierre de sesión
    setTimeout(() => {
      this.authService.logoutSessiontimer();
    }, 1300);
  }
  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
    this.inactivitySubscription.unsubscribe();
  }

     //Evento que escucha el movimiento del mouse
     @HostListener("window:mousemove") refreshUserState() {   
   
      clearTimeout(this.inactivityService.userActivity);
      this.inactivityService.setTimeoutInactivityNew(this.configService.config.timeInactivity);
    
    }
}
